export default __webpack_public_path__ + "static/compensation-6c47806cdbd8321bbed9239ede2d5ab4.png";